module.exports = __webpack_public_path__ + "img/cpzz5@2x.9aad24b0.png";